<template>
  <div class="b2c-order">
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row class="pb-1">
          <b-col cols="12">
            <h4>
              Danh sách đơn hàng <a v-b-tooltip.hover.top="'Lấy lại danh sách!'" class="btn-icon ml-1"
                                    @click="$router.go()">
              <feather-icon icon="RepeatIcon"/>
            </a>
              <export-excel
                  id="export-excel"
                  v-b-tooltip.hover.top="'Export excel!'"
                  :data="rows"
                  class="btn-icon ml-1"
                  name="oppo-order.xls"
                  rolt="button"
                  worksheet="My Worksheet">
                <feather-icon icon="DownloadIcon"/>
              </export-excel>
              <span class="float-right">
              <b-input-group>
                <b-form-input v-model="searchString" placeholder="Tìm kiếm nhanh" size="sm"
                              @keypress.enter="quickSearch"/>
                <b-input-group-append is-text role="button" @click="quickSearch">
                  <feather-icon icon="SearchIcon"/>
                </b-input-group-append>
              </b-input-group>
            </span>
            </h4>
          </b-col>
          <b-col cols="12">
            <b-tabs>
              <b-tab active title="Tất cả đơn hàng" @click="changeTab(null)">
              </b-tab>
              <b-tab
                  title="Đơn chờ thanh toán" @click="changeTab(0)"
              >
              </b-tab>
              <b-tab
                  title="Chờ xác nhận" @click="changeTab(1)"
              >
              </b-tab>
              <b-tab
                  title="Đã xác nhận" @click="changeTab(2)"
              >
              </b-tab>
              <b-tab
                  title="Hoàn tất" @click="changeTab(3)"
              >
              </b-tab>
              <b-tab
                  title="Đơn hàng lỗi" @click="changeTab(90)"
              >
              </b-tab>
              <b-tab
                  title="Trả hàng" @click="changeTab(91)"
              >
              </b-tab>
            </b-tabs>
          </b-col>
          <!-- Per Page -->
        </b-row>

        <b-row>
          <b-col cols="12">
            <vue-good-table :columns="fields" :isLoading.sync="isLoading" :line-numbers="true"
                            :pagination-options="{perPage: serverParams.pageSize,enabled: true,perPageDropdown: [20,50,100],dropdownAllowAll: false}"
                            :rows="rows"
                            :totalRows="totalRecords"
                            mode="remote"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
            >
              <template
                  slot="table-row"
                  slot-scope="props"
              >

                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                <b-dropdown no-caret size="sm" toggle-class="text-decoration-none" variant="link">
                  <template v-slot:button-content>
                    <feather-icon class="text-body align-middle mr-25" icon="MoreVerticalIcon" size="16"/>
                  </template>
                  <b-dropdown-item @click="view(props.index)">
                    <feather-icon class="mr-50" icon="EyeIcon"/><span>Xem chi tiết</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="viewChangetstaus(props.index)">
                    <feather-icon class="mr-50" icon="Edit3Icon"/><span>Chuyển trạng thái</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="viewUpdateShipment(props.index)">
                    <feather-icon class="mr-50" icon="RadioIcon"/><span>Cập nhật mã vận đơn</span>
                  </b-dropdown-item>
                </b-dropdown>
              </span>
                <span v-else-if="props.column.field === 'Color'">
                <span v-for="(p,stt) in props.row.JSON.cart.filter(i=>i.origin_type== 'oppo')"" :key="stt">
                  <b-badge v-if="p.variants && p.variants.find(m=>m.selected) && p.variants.find(m=>m.selected).selected && p.variants.find(m=>m.selected).selected.name"
                           :style="'background:'+p.variants.find(m=>m.selected).selected.value"
                           class="border text-secondary">{{ p.variants.find(m => m.selected).selected.name }}</b-badge>
                  <b-badge v-else-if="p.variants && p.variants.find(m=>m.selected) && p.variants.find(m=>m.selected).selected"
                           :style="'background:'+p.variants.find(m=>m.selected).selected"
                           class="border text-secondary ml-1">X</b-badge>
                </span>
                </span>
                <span v-else-if="props.column.field === 'IsFast'">
                <feather-icon v-if="props.row.IsFast==1" icon="CheckIcon"/>
              </span>
                <span v-else-if="props.column.field === 'TotalPrice'">
                {{ props.formattedRow[props.column.field]|number }}
              </span>
                <span v-else-if="props.column.field === 'Devices'">
                <span v-html="getDeviceName(props.row)"/>
              </span>
                <span v-else-if="props.column.field === 'Id'">
                <a class="font-weight-bold" @click="view(props.index)">{{ props.row.Id }}</a>
              </span>
                <span v-else-if="props.column.field === 'PaymentChannel'">
                <a class="text">{{ props.row.PaymentChannel == 'BANKTRANFER' ? 'Chuyển khoản' : props.row.PaymentChannel }}</a>
              </span>
                <span v-else-if="props.column.field === 'GHTK_Id'">
                <a v-if="props.row && props.row.IsFast==1 && props.row.J_Shipment"
                   :href="props.row.J_Shipment.shared_link" target="_blank">{{ props.row.GHTK_Id }}</a>
                <a v-else :href="'https://jtexpress.vn/vi/tracking?type=track&billcode='+props.row.GHTK_Id"
                   target="_blank">{{ props.row.GHTK_Id }}</a>
              </span>
                <span v-else-if="props.column.field === 'Status'">
                <span class="badge badge-light-info">{{ statusList.find(m => m.id == props.row.Status).text }}</span>
              </span>
                <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>

              </template>
            </vue-good-table>
          </b-col>

        </b-row>
      </div>
    </b-card>
    <b-modal id="modal-change-status" :title="'Thay đổi trạng thái đơn '+ currentItem.Id" @ok="handleChangeStatus">
      <validation-observer ref="modalView">
        <b-row>
          <b-col cols="12">
            <b-form-group label="Trạng thái mới">
              <Select2 v-model="currentItem.newStatus" :options="statusList.filter(i=>i.id!=90)"/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Ghi chú">
              <b-form-textarea v-model="currentItem.notes"/>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal id="modal-shipment" :title="'Cập nhật mã giao vận '+ currentItem.Id" @ok="handleShipmentUpdate">
      <validation-observer ref="modalView1">
        <b-row>
          <b-col cols="12">
            <b-form-group label="Mã giao vận">
              <b-form-input v-model="shipment_id" placeholder="Nhập mã giao vận" size="sm"/>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal id="modal-view" :title="'Thông tin đơn hàng '+ currentItem.Id" ok-only size="xl" @hide="handleHide"
             @ok="handleOk">
      <validation-observer ref="modalView">
        <b-row class="border-bottom pb-1 mb-1">
          <b-col v-for="i in statusList" :key="i.id" :class="i.has?'text-primary':''" cols="2">
            <feather-icon v-if="currentItem.Status>=i.id" icon="CheckSquareIcon"/>
            {{ i.text }}
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            <h4>Thông tin khách hàng</h4>
            <b-card body-class="p-1">
              <b-card-text>
                <b-row>
                  <b-col cols="12">
                    <b-form-group label="Tên khách hàng">
                      <b-form-input v-model="currentItem.FullName" disabled size="sm"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="5">
                    <b-form-group label="Số liên hệ">
                      <b-form-input v-model="currentItem.ContactPhone" :disabled="!isEditPhoneEmail" size="sm"/>
                    </b-form-group>
                  </b-col>
                  <b-col class="pl-0" cols="7">
                    <b-form-group label="Email">
                      <b-form-input v-model="currentItem.Email" :disabled="!isEditPhoneEmail" size="sm"/>
                    </b-form-group>
                  </b-col>
                  <!-- <b-col cols="12" :class="[{'mb-3': !currentItem.DeliveryType==1 || !currentItem.City},'text-right']"><b-button variant="primary" @click="updatePhoneAndMail" size="sm">{{ isEditPhoneEmail ? 'Lưu' : 'Sửa' }}</b-button></b-col> -->
                  <b-col v-if="currentItem.DeliveryType==1 && currentItem.City" cols="12">
                    <b-row>
                      <b-col cols="12">
                        <b-form-group label="Tỉnh/Thành phố">
                          <search-select
                              v-model="currentItem.CityId"
                              :disabled="!(isEditPhoneEmail && currentItem.Status==1)"
                              :options="Cities"
                              @change="fetchDistricts(true)"
                          ></search-select>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Quận/Huyện">
                          <search-select
                              v-model="currentItem.DistrictId"
                              :disabled="!(isEditPhoneEmail && currentItem.Status==1)"
                              :options="Districts"
                              @change="fetchWards(true)"
                          ></search-select>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Phường/Xã/Thị trấn">
                          <search-select
                              v-model="currentItem.WardId"
                              :disabled="!(isEditPhoneEmail && currentItem.Status==1)"
                              :options="Wards"
                              @change="fetchHamlet(true)"
                          ></search-select>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="ẤP/Khu/Tòa">
                          <search-select
                              v-model="currentItem.HamletId"
                              :disabled="!(isEditPhoneEmail && currentItem.Status==1)"
                              :options="hamlets"
                          ></search-select>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Địa chỉ">
                          <b-form-input v-model="currentItem.Addr" :disabled="!(isEditPhoneEmail && currentItem.Status==1)"
                                        size="sm"/>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="9">
                    <b-form-group label="">
                      <b-form-checkbox v-model="currentItem.IsFast" disabled value="1">
                        Giao hàng hoả tốc
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="currentItem.IsFast==1" class="text-right" cols="3"><span v-if="currentItem.GHTK_Id"
                                                                                        class="text-primary"
                                                                                        role="button"
                                                                                        @click="ahmOrderCancel">Huỷ đơn</span>
                  </b-col>
                  <b-col v-if="currentItem.DeliveryType==1" class="text-right d-flex justify-content-end col-gap-1"
                         cols="12">
                    <b-button size="sm" variant="primary" @click="updatePhoneAndMail">
                      {{ isEditPhoneEmail ? 'Lưu' : 'Sửa' }}
                    </b-button>
                    <b-button size="sm" variant="primary" @click="createShipment">Tạo vận đơn</b-button>
                    <b-button v-if="currentItem.GHTK_Id" size="sm" variant="secondary" @click="createShipment1">Tạo đơn
                      mới
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card>
            <h4 class="hidden">Các số iTel trong đơn</h4>
            <b-card v-if="currentItem.ListPhones && !isLoading" body-class="p-0" class="hidden">
              <b-card-text>
                <table class="table table-striped">
                  <tr v-for="p in currentItem.ListPhones" :key="p.Msisdn">
                    <td class="p-1">
                      <b-row>
                        <b-col class="text-primary h4 border-bottom pb-1" cols="12">{{ p.Msisdn }}<br><small
                            class="text-secondary">MSIN: <b>{{ p.MSIN_ }}</b></small></b-col>
                      </b-row>

                      <b-row>
                        <b-col cols="6">Loại SIM:</b-col>
                        <b-col cols="6">
                        <span>
                          <feather-icon :icon="p.ESIM==1?'CheckSquareIcon':'SquareIcon'"/> eSIM?
                        </span>
                        </b-col>
                        <b-col class="bg-light" cols="6">Giá số:</b-col>
                        <b-col class="bg-light" cols="6">{{ p.Price|number }}/tháng</b-col>
                        <b-col cols="6">Giá SIM/eSIM:</b-col>
                        <b-col v-if="p.ESIM==1" cols="6">{{ p.EsimPrice|number }}</b-col>
                        <b-col v-else cols="6">{{ p.SimPrice|number }}</b-col>
                        <b-col class="bg-light" cols="6">Gói: {{ p.Package }}</b-col>
                        <b-col class="bg-light" cols="6">{{ p.PackPrice|number }}/tháng</b-col>
                        <b-col cols="6">Cam kết:</b-col>
                        <b-col cols="6">{{ p.Months }} tháng</b-col>
                        <b-col class="bg-light" cols="6">Khởi tạo?</b-col>
                        <b-col class="bg-light" cols="6">
                          <feather-icon :icon="p.Active==2?'CheckSquareIcon':'SquareIcon'"/>
                          Active?
                        </b-col>
                        <b-col cols="6">DKTT:</b-col>
                        <b-col cols="6"><span v-if="p.IDNUMBER">Đã đăng ký</span><span v-else>Chưa đăng ký</span>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col class="pt-1 text-right" cols="12">
                          <b-button size="sm" variant="primary" @click="reActive(p.Msisdn,p.MSIN)">Khởi tạo</b-button>
                          <b-button class="ml-1 btn-icon" size="sm" variant="primary" @click="rePrint(p.Msisdn,p.MSIN)">
                            <feather-icon icon="PrinterIcon"/>
                          </b-button>
                          <b-button v-if="p.ESIM==1" class="mr-1 ml-1" size="sm" variant="primary"
                                    @click="esimEmail(p.Msisdn)">Gửi Email eSIM
                          </b-button>
                        </b-col>
                      </b-row>
                    </td>
                  </tr>
                </table>
              </b-card-text>
            </b-card>
            <h4>Tổng tiền <span class="text-primary">{{ currentItem.TotalPrice|number }}</span><small
                v-if="currentItem && currentItem.ListPhones && currentItem.ListPhones.find(m=>m.ESIM==0)!=undefined">
              (15.000đ VC)</small></h4>
          </b-col>
          <b-col cols="9">
            <h4>Thông tin thanh toán</h4>
            <div class="border rounded bg-light p-1">
              <b-row v-if="currentItem.J_VnPay && !isLoading">
                <b-col cols="3">
                  <b-form-group label="Mã GD">
                    <b-form-input v-model="currentItem.J_VnPay.vnp_TransactionNo" disabled size="sm"/>
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group label="Loại thẻ">
                    <b-form-input v-model="currentItem.J_VnPay.vnp_CardType" disabled size="sm"/>
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group label="Ngân hàng">
                    <b-form-input v-model="currentItem.J_VnPay.vnp_BankCode" disabled size="sm"/>
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group label="Ngày/tháng">
                    <b-form-input :value="dateFormat(currentItem.J_VnPay.vnp_PayDate)" disabled size="sm"/>
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group label="Số tiền">
                    <b-form-input :value="$options.filters.number(currentItem.J_VnPay.vnp_Amount/100)" disabled
                                  size="sm"/>
                  </b-form-group>
                </b-col>
                <b-col cols="9">
                  <b-form-group label="Trạng thái">
                    <b-form-input v-model="currentItem.J_VnPay.vnp_Status" disabled size="sm"/>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <h4 class="pt-2">Thông tin vận chuyển</h4>
            <div class="border rounded bg-light p-1">
              <span
                  v-if="currentItem.DeliveryType==2">Đơn nhận tại PGD {{ currentItem.StoreId && Stores.find(el => el.value == currentItem.StoreId) ? Stores.find(el => el.value == currentItem.StoreId).text : 'Itel' }}</span>
              <span v-else-if="currentItem.GHTK_Id==null">Chưa có đơn vận chuyển</span>
              <span v-else>
              <b-row v-if="!isLoading">
                <b-col cols="3">
                  <b-form-group label="Mã vận đơn">
                    <b-form-input v-model="currentItem.GHTK_Id" disabled size="sm"/>
                  </b-form-group>
                </b-col>
                <b-col cols="9">
                  <b-form-group label="Địa chỉ">
                    <b-form-input v-model="currentItem.Addr" disabled size="sm"/>
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group label="Tỉnh/Tp">
                    <b-form-input v-model="currentItem.City" disabled size="sm"/>
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group label="Quận/Huyện">
                    <b-form-input v-model="currentItem.District" disabled size="sm"/>
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group label="Phường/Xã">
                    <b-form-input v-model="currentItem.Ward" disabled size="sm"/>
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group label="Tổ/Khu">
                    <b-form-input v-model="currentItem.Hamlet" disabled size="sm"/>
                  </b-form-group>
                </b-col>
              </b-row>
              <h5 class="border-bottom">Trạng thái vận đơn chi tiết</h5>
              <b-row v-if="currentItem.IsFast==0">
                <b-col v-for="i in currentItem.J_Shipment_Tracking" :key="i.date_" class="pt-1" cols="12"><span
                    class="badge badge-light-secondary">{{ i.date_ }}</span> {{ ghtkStatus.find(m => m.id == i.status).text }}</b-col>
              </b-row>
              <b-row v-else>
                <b-col v-for="i in currentItem.J_Shipment_Tracking" :key="i.date_" class="pt-1" cols="12"><span
                    class="badge badge-light-secondary">{{ i.date_ }}</span> {{ ahmStatus.find(m => m.id == i.status).text }}</b-col>
              </b-row>
            </span>
            </div>
            <h4 class="pt-2">Danh sách sản phẩm</h4>
            <div v-if="currentItem && currentItem.JSON" class="">
              <table class="table table-sm table-bordered table-striped">
                <tr>
                  <th>Tên sản phẩm</th>
                  <th>Số lượng</th>
                  <th>Màu sắc</th>
                  <th>RAM</th>
                  <th>Bộ nhớ trong</th>
                  <th>Giá gốc</th>
                  <th>Giá bán</th>
                </tr>
                <tr v-for="(i,stt) in currentItem.JSON.cart.filter(i=>i.product_type!=100 && i.origin_type!='baseus')"
                    :key="stt">
                  <td class="text-primary">{{ i.product_name }}</td>
                  <td>{{ i.amount }}</td>
                  <td>
                    <b-badge v-if="i.variants && i.variants.find(m=>m.selected) && i.variants.find(m=>m.selected).selected && i.variants.find(m=>m.selected).selected.name"
                             :style="'background:'+i.variants.find(m=>m.selected).selected.value"
                             class="border text-secondary">
                      {{ i.variants.find(m => m.selected).selected.name }}
                    </b-badge>
                    <b-badge v-else-if="i.variants && i.variants.find(m=>m.selected) && i.variants.find(m=>m.selected).selected"
                             :style="'background:'+i.variants.find(m=>m.selected).selected"
                             class="border text-secondary ml-1">
                      X
                    </b-badge>
                  </td>
                  <td>{{ i.attributes ? i.attributes.ram || '' : '' }}</td>
                  <td>{{ i.attributes ? i.attributes.rom || '' : '' }}</td>
                  <td>{{ i.base_price|number }}</td>
                  <td>{{ i.price|number }}</td>
                </tr>
              </table>
            </div>
            <h4 class="pt-2">Ghi chú</h4>
            <div class="border rounded bg-light p-1">
              {{ currentItem.Notes }}
            </div>
            <b-row class="pt-1 font-small">
              <b-col cols="12">
                <h5>Tin nhắn/Email</h5>
                <b-card body-class="p-0" class="p-0 mb-1">
                  <b-card-text>
                    <table class="table table-bordered table-sm">
                      <tr>
                        <th>Loại</th>
                        <th>Tin nhắn</th>
                        <th>Ngày</th>
                      </tr>
                      <tr v-for="i in this.currentItem.notify" :key="i.Id">
                        <td>{{ i.NotifyType }}</td>
                        <td>{{ i.Result }}</td>
                        <td>{{ i.date_ }}</td>
                      </tr>
                    </table>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col cols="12">
                <h5>Logs</h5>
                <b-card v-if="currentItem.logs" body-class="p-0" class="p-0">
                  <b-card-text style="overflow:auto">
                    <table class="table table-bordered table-sm">
                      <tr>
                        <th>Loại</th>
                        <th>Logs</th>
                        <th>Ngày</th>
                      </tr>
                      <tr v-for="i in currentItem.logs" :key="i.Id">
                        <td>{{ i.LogType }}</td>
                        <td>{{ i.Content }}</td>
                        <td>{{ i.date_ }}</td>
                      </tr>
                    </table>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal id="modal-dktt" :title="'Thông tin lịch sử đăng ký TTTB'" ok-only size="xl">

    </b-modal>
  </div>
</template>

<script>


import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {required} from '@validations'
import vSelect from 'vue-select'
import {VueGoodTable} from 'vue-good-table'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip
} from 'bootstrap-vue'
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from 'vue-ripple-directive'
import '@core/scss/vue/libs/vue-good-table.scss';
import Select2 from 'v-select2-component';
import moment from 'moment';
import SearchSelect from "../components/select/SearchSelect.vue";
import Vue from 'vue'
import excel from 'vue-excel-export'
import {OriginType} from '@/libs/acl/config';

Vue.use(excel)

export default {

  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BTabs,
    BTab,
    BCardText,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    SearchSelect
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mounted() {
    this.loadMasterData();
  },
  watch: {
    $route(to, from) {
      this.loadMasterData();
    }
  },
  methods: {
    /*viewDKTTHist(p){
      console.log(p);
      this.dkttRows = p.reg_hist;
      this.$bvModal.show('modal-dktt');
    },*/
    exportExcel() {

    },
    getDeviceName(p) {
      //console.log(p);
      var x = '';
      p.JSON.cart.forEach(i => {
        if (i.product_type != 100 && i.origin_type != OriginType.BASUES) {
          x += i.product_name + '<br>';
        }
      });
      return x;
    },
    createShipment1() {
      if (confirm("Chỉ tạo vận đơn mới khi vận đơn cũ không tạo lại được!")) {
        this.loading(true);
        useJwt.get('ghtk/create-order-force/' + this.currentItem.Id).then(response => {
          this.$toast({
            component: ToastificationContent,
            props: {title: response.data.result.message, icon: 'AlertTriangleIcon', variant: 'info'}
          })
          console.log(response.data.result);
          this.loading(false);
        }).catch(error => {
          if (error.response.data.code == 403) {
            this.$toast({
              component: ToastificationContent,
              props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
            })
          }
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result.message, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
          this.loading(false);
        })
      }
    },
    createShipment() {
      this.loading(true);
      useJwt.get('ghtk/create-order/' + this.currentItem.Id).then(response => {
        this.$toast({
          component: ToastificationContent,
          props: {title: 'Tạo đơn vận thành công', icon: 'AlertTriangleIcon', variant: 'info'}
        })
        console.log(response.data.result);
        this.loading(false);
      }).catch(error => {
        if (error.response.data.code == 403) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        }
        this.$toast({
          component: ToastificationContent,
          props: {title: error.response.data.result.message, icon: 'AlertTriangleIcon', variant: 'warning'}
        })
        this.loading(false);
      })
    },
    updatePhoneAndMail() {
      if (!this.isEditPhoneEmail) {
        this.isEditPhoneEmail = true;
        return;
      }

      this.loading(true);
      const data = {
        ContactPhone: this.currentItem.ContactPhone,
        Email: this.currentItem.Email,
        OrderId: this.currentItem.Id,
        Addr: this.currentItem.Addr,
        CityId: this.currentItem.CityId,
        DistrictId: this.currentItem.DistrictId,
        WardId: this.currentItem.WardId,
      }

      useJwt.put('update-order-info/' + this.currentItem.Id, data).then(response => {
        this.$toast({
          component: ToastificationContent,
          props: {title: response.data.message, icon: 'AlertTriangleIcon', variant: 'info'}
        });
        this.isEditPhoneEmail = false;
        this.loading(false);
      }).catch(error => {
        if (error.response.data.code == 403) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        }
        this.isEditPhoneEmail = false;
        this.loading(false);
      })
    },
    reActive(msisdn, msin) {
      this.loading(true);
      useJwt.post('sps/createSub2', {orderId: this.currentItem.Id, msisdn: msisdn, msin: msin}).then(response => {
        console.log(response.data.result);
        this.$toast({
          component: ToastificationContent,
          props: {title: response.data.result.createSub, icon: 'AlertTriangleIcon', variant: 'info'}
        })
        this.loading(false);
      }).catch(error => {
        if (error.response.data.code == 403) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        }
        this.loading(false);
      })
    },
    rePrint(msisdn, msin) {
      this.loading(true);
      useJwt.post('sps/printSub', {orderId: this.currentItem.Id, msisdn: msisdn, msin: msin}).then(response => {
        console.log(response.data.result);
        this.$toast({
          component: ToastificationContent,
          props: {title: response.data.result.createSub, icon: 'AlertTriangleIcon', variant: 'info'}
        })
        this.loading(false);
      }).catch(error => {
        if (error.response.data.code == 403) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        }
        this.loading(false);
      })
    },
    esimEmail(msisdn) {
      this.loading(true);
      useJwt.get('send-mail-esim/' + this.currentItem.Id + "/" + msisdn).then(response => {
        console.log(response.data.result);
        this.$toast({
          component: ToastificationContent,
          props: {title: 'Kết quả: ' + response.data.result, icon: 'AlertTriangleIcon', variant: 'info'}
        })
        this.loading(false);
      }).catch(error => {
        if (error.response.data.code == 403) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        }
        this.loading(false);
      })
    },
    dateFormat(v) {
      return moment(v, 'YYYYMMDDHHmmss').format('DD/MM/YYYY hh:mm:ss')
    },
    changeTab(i) {
      this.serverParams.columnFilters.searchString = null;
      this.serverParams.columnFilters.Status = i;
      this.loadItems();
    },
    quickSearch() {
      this.serverParams.columnFilters.Status = null;
      this.serverParams.columnFilters.searchString = this.searchString;
      this.loadItems();
    },
    loadMasterData() {
      this.loadItems();
      this.fetchCities();
      this.fetchStores();
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      if (this.serverParams.columnFilters.CreateDate_) {
        this.serverParams.columnFilters.FromDate = this.serverParams.columnFilters.CreateDate_;
        this.serverParams.columnFilters.ToDate = this.serverParams.columnFilters.CreateDate_;
      } else {
        if (this.serverParams.columnFilters.FromDate) {
          delete this.serverParams.columnFilters['FromDate'];
        }
        if (this.serverParams.columnFilters.ToDate) {
          delete this.serverParams.columnFilters['ToDate'];
        }
      }
    },
    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    loadItems() {
      this.loading(true);
      this.isLoading = true;
      let data = {
        ...this.serverParams,
        columnFilters: {
          ...(this.serverParams.columnFilters ? this.serverParams.columnFilters : [])
        }
      }
      if (data.columnFilters.CreateDate_ != undefined) {
        delete data.columnFilters['CreateDate_']
      }
      useJwt.post('oppo/order-list', data).then(response => {
        this.rows = response.data.result;
        //console.log(this.rows)
        this.totalRecords = response.data.totalRecords;
        this.rows.forEach(i => {
          if (i.J_Shipment) {
            i.J_Shipment = JSON.parse(i.J_Shipment);
          }
          if (i.JSON) {
            i.JSON = JSON.parse(i.JSON);
          }
        })
        this.isLoading = false;
        this.loading(false);
      }).catch(error => {
        this.loading(false);
        this.isLoading = false;
      })
    },
    viewUpdateShipment(idx) {
      this.isLoading = true;
      this.currentItem = this.rows[idx];
      this.$bvModal.show('modal-shipment');
      this.isLoading = false;
    },
    viewChangetstaus(idx) {
      this.currentItem.newStatus = this.currentItem.Status;
      this.isLoading = true;
      this.currentItem = this.rows[idx];
      this.$bvModal.show('modal-change-status');
      this.isLoading = false;
    },
    ahmOrderCancel() {
      if (confirm("Bạn thực sự muốn xoá vận đơn Ahamove?")) {
        this.loading(true);
        useJwt.get('cancel/' + this.currentItem.GHTK_Id + "/Xoá vận đơn từ CRM").then(response => {
          this.$toast({
            component: ToastificationContent,
            props: {title: response.data.message, icon: 'AlertTriangleIcon', variant: 'info'}
          })
          console.log(response.data.result);
          this.loading(false);
        }).catch(error => {
          if (error.response.data.code == 403) {
            this.$toast({
              component: ToastificationContent,
              props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
            })
          }
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result.message, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
          this.loading(false);
        })
      }
    },
    handleChangeStatus(bvModalEvt) {
      bvModalEvt.preventDefault()
      useJwt.put('order/' + this.currentItem.Id + '/' + this.currentItem.newStatus, {notes: this.currentItem.notes}).then(response => {
        this.loadItems();
        this.loading(false);
        this.$bvModal.hide('modal-change-status');
      }).catch(error => {
        if (error.response.data.code == 403) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        }
        this.loading(false);
      })
    },
    handleShipmentUpdate(bvModalEvt) {
      bvModalEvt.preventDefault()
      useJwt.put('oppo/order/' + this.currentItem.Id + '/' + this.shipment_id).then(response => {
        this.loadItems();
        this.loading(false);
        this.$bvModal.hide('modal-shipment');
      }).catch(error => {
        if (error.response.data.code == 403) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        }
        this.loading(false);
      })
    },
    view(idx) {
      this.isLoading = true;
      this.currentItem = this.rows[idx];
      try {
        if (this.currentItem.J_VnPay != null) {
          this.currentItem.J_VnPay = JSON.parse(this.currentItem.J_VnPay);
        }
        if (this.currentItem.J_Shipment_Tracking != null) {
          this.currentItem.J_Shipment_Tracking = JSON.parse(this.currentItem.J_Shipment_Tracking);
        }
      } catch (e) {
      }
      if (this.currentItem.J_VnPay && this.currentItem.J_VnPay.vnp_ResponseCode) {
        var x = this.vnPayErrors.find(m => m.id == this.currentItem.J_VnPay.vnp_ResponseCode);
        if (x != undefined) {
          this.currentItem.J_VnPay.vnp_Status = x.text
        } else {
          this.currentItem.J_VnPay.vnp_Status = 'Trạng thái không xác định - ' + this.currentItem.J_VnPay.vnp_ResponseCode
        }

      }
      this.loading(true);
      if (this.currentItem.CityId) {
        this.fetchDistricts(false, false)
        this.fetchWards(false, false)
        this.fetchHamlet(false, false)
      }
      useJwt.get('order-detail/' + this.currentItem.Id).then(response => {
        this.currentItem.ListPhones = response.data.result.phones;
        this.currentItem.steps = response.data.result.steps.filter(m => m.LogType == 'Order-Status');
        this.currentItem.logs = response.data.result.steps
        this.currentItem.notify = response.data.result.notify;
        this.currentItem.dktts = response.data.result.dktts;
        this.statusList.forEach(m => m.has = false);
        this.currentItem.steps.forEach(i => {
          var s = this.statusList.find(m => m.id == i.Content);
          if (s != undefined) {
            s.has = true;
          }
        })
        var s1 = this.statusList.find(m => m.id == this.currentItem.Status);
        if (s1 != undefined) {
          s1.has = true;
        }
        //console.log(this.currentItem);
        //console.log(this.statusList.find(m=>m.id==this.currentItem.Status));
        this.currentItem = JSON.parse(JSON.stringify(this.currentItem))
        this.loading(false);
        this.$bvModal.show('modal-view');
        this.isLoading = false;
      }).catch(error => {
        this.loading(false);
        this.isLoading = false;
      })
    },
    async handleOk(bvModalEvt) {

    },
    handleHide() {
      this.loadItems();
      this.isEditPhoneEmail = false;
    },
    async fetchCities() {
      try {
        const res = await useJwt.post("getMasterData/GHTK_City", {
          columnFilters: {},
          sort: [],
          page: 1,
          pageSize: 1000
        });

        this.Cities = res.data.result.map((item) => {
          return {
            value: item.Id,
            text: item.Name,
          };
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {title: 'Có lỗi trong quá trình lấy dữ liệu!', icon: 'AlertTriangleIcon', variant: 'warning'}
        })
      }
    },
    async fetchDistricts(isCityChange = false, showLoading = true) {
      if (isCityChange) {
        this.currentItem.DistrictId = 0;
        this.currentItem.WardId = 0;
      }

      if (this.currentItem.CityId > 0) {
        if (showLoading) {
          this.loading(true);
        }
        useJwt.post("getMasterData/GHTK_District", {
          columnFilters: {CityId: this.currentItem.CityId},
          sort: [],
          page: 1,
          pageSize: 1000,
        })
            .then((response) => {
              this.Districts = response.data.result.map((item) => {
                return {
                  value: item.Id,
                  text: item.Name,
                };
              });
              if (showLoading) {
                this.loading(false);
              }
            });
      }
    },
    async fetchWards(isDistrictChange = false, showLoading = true) {
      if (isDistrictChange) {
        this.currentItem.WardId = 0;
      }

      if (this.currentItem.DistrictId > 0) {
        if (showLoading) {
          this.loading(true);
        }

        useJwt.post("getMasterData/GHTK_Ward", {
          columnFilters: {DistrictId: this.currentItem.DistrictId},
          sort: [],
          page: 1,
          pageSize: 1000,
          lang: this.$l,
        })
            .then((response) => {
              this.Wards = response.data.result.map((item) => {
                return {
                  value: item.Id,
                  text: item.Name,
                };
              });
              if (showLoading) {
                this.loading(false);
              }
            });
      }
    },
    async fetchHamlet(isDistrictChange = false, showLoading = true) {
      if (isDistrictChange) {
        this.currentItem.HamletId = 0;
      }

      if (this.currentItem.WardId > 0) {
        if (showLoading) {
          this.loading(true);
        }

        useJwt.post("getMasterData/GHTK_Hamlet", {
          columnFilters: {WardId: this.currentItem.WardId},
          sort: [],
          page: 1,
          pageSize: 1000,
          lang: this.$l,
        })
            .then((response) => {
              this.hamlets = response.data.result.map((item) => {
                return {
                  value: item.Id,
                  text: item.Name,
                };
              });
              if (showLoading) {
                this.loading(false);
              }
            });
      }
    },
    async fetchStores() {
      useJwt.post("getMasterData/B2C_Store", {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 1000
      })
          .then((response) => {
            this.Stores = response.data.result.map((item) => {
              return {
                value: item.Id,
                text: item.Name,
              };
            });
          })
          .catch((err) => {
            this.$toast({
              component: ToastificationContent,
              props: {title: 'Có lỗi trong quá trình lấy dữ liệu!', icon: 'AlertTriangleIcon', variant: 'warning'}
            })
          });
    },
  },
  data() {
    return {
      isEditPhoneEmail: false,
      searchString: "",
      isLoading: false,
      totalRecords: 0,
      shipment_id: '',
      rows: [],
      //dkttRows:[],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      searchTerm: '',
      currentItem: {},
      Cities: [],
      Districts: [],
      Wards: [],
      Stores: [],
      hamlets: [],
      fields: [
        {
          field: 'Id',
          filterOptions: {enabled: true, placeholder: '', trigger: 'enter'},
          label: 'Mã đơn hàng',
          width: '150px'
        },
        {
          field: 'CreateDate_',
          filterOptions: {enabled: true, placeholder: '', trigger: 'enter'},
          label: 'Ngày tạo',
          width: '130px'
        },
        {
          field: 'FullName',
          filterOptions: {enabled: true, placeholder: '', trigger: 'enter'},
          label: 'Họ tên KH',
        },
        {
          field: 'Devices',
          filterOptions: {enabled: true, placeholder: '', trigger: 'enter'},
          label: 'Sản phẩm',
        },
        {
          field: 'TotalPrice',
          filterOptions: {enabled: true, placeholder: '', trigger: 'enter'},
          label: 'Giá',
          tdClass: 'text-right',
          width: '90px'
        },
        {
          field: 'Color',
          filterOptions: {enabled: true, placeholder: '', trigger: 'enter'},
          label: 'Màu sắc?',
          tdClass: 'text-center',
        },
        {
          field: 'PaymentChannel',
          filterOptions: {enabled: true, placeholder: '', trigger: 'enter'},
          label: 'HTTT',
          tdClass: 'text-center',
        },
        // {
        //   field: 'IsFast',
        //   filterOptions: {enabled: true, placeholder: '', trigger: 'enter'},
        //   label: 'Hoả tốc?',
        //   tdClass: 'text-center',
        //   width: '70px'
        // },
        {
          field: "PromotionCode",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Mã giảm giá?",
          tdClass: "text-center",
          width: "70px",
        },
        {
          field: 'Status',
          filterOptions: {
            enabled: true, placeholder: '',
            filterDropdownItems: [
              {value: 0, text: "Chưa thanh toán"},
              {value: 1, text: "Đã thanh toán/Chờ xác nhận"},
              {value: 2, text: "Đã xác nhận/Chuyển vận đơn"},
              {value: 3, text: "Hoàn thành giao hàng"},
              {value: 90, text: "Lỗi thanh toán"},
              {value: 91, text: "Trả hàng"}
            ],
          },
          label: 'Tình trạng?',
        },
        {
          field: 'GHTK_Id',
          filterOptions: {enabled: true, placeholder: '', trigger: 'enter'},
          label: 'Vận chuyển',
        },
        {
          field: 'CreateFrom',
          filterOptions: {enabled: true, placeholder: '', trigger: 'enter'},
          label: 'Nguồn đơn',
          width: "70px"
        },
        {
          field: 'CreateBy',
          filterOptions: {enabled: true, placeholder: '', trigger: 'enter'},
          label: 'Người tạo',
        },
        {field: 'action', label: 'Thao tác', width: '80px',}
      ],
      statusList: [
        {id: 0, text: "Chưa thanh toán"},
        {id: 1, text: "Đã thanh toán/Chờ xác nhận"},
        {id: 2, text: "Đã xác nhận/Chuyển vận đơn"},
        {id: 3, text: "Hoàn thành giao hàng"},
        {id: 90, text: "Lỗi thanh toán"},
        {id: 91, text: "Trả hàng"},
        {id: 300, text: "Khác"}
      ],
      vnPayErrors: [
        {id: "00", text: "Giao dịch thành công"},
        {id: "07", text: "Trừ tiền thành công. Giao dịch bị nghi ngờ (liên quan tới lừa đảo, giao dịch bất thường)."},
        {
          id: "09",
          text: "Giao dịch không thành công do: Thẻ/Tài khoản của khách hàng chưa đăng ký dịch vụ InternetBanking tại ngân hàng."
        },
        {
          id: "10",
          text: "Giao dịch không thành công do: Khách hàng xác thực thông tin thẻ/tài khoản không đúng quá 3 lần"
        },
        {
          id: "11",
          text: "Giao dịch không thành công do: Đã hết hạn chờ thanh toán. Xin quý khách vui lòng thực hiện lại giao dịch."
        },
        {id: "12", text: "Giao dịch không thành công do: Thẻ/Tài khoản của khách hàng bị khóa."},
        {
          id: "13",
          text: "Giao dịch không thành công do Quý khách nhập sai mật khẩu xác thực giao dịch (OTP). Xin quý khách vui lòng thực hiện lại giao dịch."
        },
        {id: "24", text: "Giao dịch không thành công do: Khách hàng hủy giao dịch"},
        {
          id: "51",
          text: "Giao dịch không thành công do: Tài khoản của quý khách không đủ số dư để thực hiện giao dịch."
        },
        {
          id: "65",
          text: "Giao dịch không thành công do: Tài khoản của Quý khách đã vượt quá hạn mức giao dịch trong ngày."
        },
        {id: "75", text: "Ngân hàng thanh toán đang bảo trì."},
        {
          id: "79",
          text: "Giao dịch không thành công do: KH nhập sai mật khẩu thanh toán quá số lần quy định. Xin quý khách vui lòng thực hiện lại giao dịch"
        },
        {id: "99", text: "Lỗi thanh toán ngân hàng, quý khách vui lòng thử lại"},
      ],
      ahmStatus: [
        {id: 'IDLE', text: 'Đã tiếp nhận'},
        {id: 'ASSIGNING', text: 'Đã điều phối lấy hàng'},
        {id: 'ACCEPTED', text: 'Đã tiếp nhận'},
        {id: 'IN PROCESS', text: 'Shipper báo đã lấy hàng'},
        {id: 'COMPLETED', text: 'Hoàn thành đơn hàng'},
        {id: 'CANCELLED', text: 'Hủy đơn hàng'},
      ],
      ghtkStatus: [
        {id: '-1', text: 'Hủy đơn hàng'},
        {id: '1', text: 'Chưa tiếp nhận'},
        {id: '2', text: 'Đã tiếp nhận'},
        {id: '3', text: 'Đã lấy hàng/Đã nhập kho'},
        {id: '4', text: 'Đã điều phối giao hàng/Đang giao hàng'},
        {id: '5', text: 'Đã giao hàng/Chưa đối soát'},
        {id: '6', text: 'Đã đối soát'},
        {id: '7', text: 'Không lấy được hàng'},
        {id: '8', text: 'Hoãn lấy hàng'},
        {id: '9', text: 'Không giao được hàng'},
        {id: '10', text: 'Delay giao hàng'},
        {id: '11', text: 'Đã đối soát công nợ trả hàng'},
        {id: '12', text: 'Đã điều phối lấy hàng/Đang lấy hàng'},
        {id: '13', text: 'Đơn hàng bồi hoàn'},
        {id: '20', text: 'Đang trả hàng (COD cầm hàng đi trả)'},
        {id: '21', text: 'Đã trả hàng (COD đã trả xong hàng)'},
        {id: '123', text: 'Shipper báo đã lấy hàng'},
        {id: '127', text: 'Shipper (nhân viên lấy/giao hàng) báo không lấy được hàng'},
        {id: '128', text: 'Shipper báo delay lấy hàng'},
        {id: '45', text: 'Shipper báo đã giao hàng'},
        {id: '49', text: 'Shipper báo không giao được giao hàng'},
        {id: '410', text: 'Shipper báo delay giao hàng'},
      ],
      serverParams: {
        "columnFilters": {},
        "sort": [
          {"field": "CreateDate", "type": "desc"}
        ],
        "page": 1,
        "pageSize": 50,
        "lang": 1
      },
      required
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style>
.b2c-order .vgt-wrap {
  max-height: calc(100vh - 300px);
  overflow: auto;
}

.font-small .table-sm {
  font-size: 11px;
}

.col-gap-1 {
  column-gap: 1rem
}

.vgt-responsive {
  min-height: 300px;
}

#export-excel {
  display: inline;
}
</style>
